import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';

import styles from './table.module.css';

const PaginationButton = ( {
	content,
	disabled,
	onClick
} ) => {
	return (
		<Button
			className={ styles.paginationButton }
			content={ content }
			disabled={ disabled }
			onClick={ onClick }
			size="small"
		/>
	);
};

PaginationButton.propTypes = {
	content: PropTypes.string.isRequired,
	disabled: PropTypes.bool,
	onClick: PropTypes.func.isRequired
};

export default memo( PaginationButton );
